<template>
  <modal @before-open="beforeOpen" @opened="opened" name="feedback" :draggable="'.header'" :reset="true"
         :classes="['feedback','generalbox']" :adaptive="true"
          :height="'900px'" :width="'710px'" :click-to-close="false" :pivotX="1" :pivotY="1">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>留言反馈
        <button @click="toFeedbackList">{{!currViewMode?'查看我的反馈':'填写留言反馈'}}</button>
      </h2>
    </div>
    <div v-if="!currViewMode" class="content">
      <div class="fdblock service">
        <p>请选择反馈的服务：</p>
        <multiselect v-model="appName"
                     :options="systemList"
                     :label="'name'"
                     placeholder="请选择应用名称"
                     :multiple="false"
                     :show-labels="false"
                     :clear-on-select="false"
                     :close-on-select="true"
                     :allow-empty="true"
                     :taggable="true"
        ></multiselect>
      </div>


      <div class="fdblock editor">
        <p>请填写反馈内容：</p>
        <v-editor-app v-model="feedbackContent"></v-editor-app>
      </div>
      <div class="fdblock link">
        <p>请填写联系方式：</p>
        <input v-model="linkway" class="linkway" type="text"/>
      </div>
      <div class="fdblock link">
        <p><input v-model="isAnon" name="isAnon" id="isAnon" class="checkbox" type="checkbox"/><label
            for="isAnon">是否匿名</label></p>

      </div>

      <button @click="submitFeedback" class="submitBtn">提交反馈</button>
      <button @click="resetForm" class="submitBtn">重置</button>


    </div>
    <div v-if="currViewMode" class="content">
      <div class="feedbackListContainer">
        <div v-if="!feedbackList.length" class="empty">
          暂无数据
        </div>
        <ul class="feedbackList">
          <li @click="viewFeedbackDetail(feedback)" v-for="feedback in feedbackList">
            <h2 v-html="getDescribe(feedback.describe)"></h2>
            <p>{{feedback.createddate}}</p>
            <div class="state">{{getReplyStateDesc(feedback.state)}}</div>
          </li>
        </ul>
        <div v-if="currFeedbackId" class="detailContainer">
          <feedback-detail @clearCurrFeedbackId="clearCurrFeedbackId" :feedbackId="currFeedbackId"></feedback-detail>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  import multiselect from 'vue-multiselect';
  import feedbackDetail from 'components/globalComp/feedbackDetail'
  //通信总线
  import Bus from 'common/js/bus.js';

  export default {
    name: "feedback",
    data() {
      return {
        appName: null,
        //反馈内容
        feedbackContent: null,
        //联系方式
        linkway: null,
        //是否匿名
        isAnon: null,
        //当前视图id 0 提交留言视图 1 留言列表视图
        currViewMode: 0,
        //意见反馈列表
        feedbackList: null,
        //留言反馈id
        currFeedbackId: null


      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        if (this.$route.path.indexOf("/home") !== -1) {
          this.$store.commit("toggleSideMenuShow", false);
        }
        this.resetForm()
        this.$modal.hide("feedback");
      },
      beforeOpen(data) {
        this.$store.commit("toggleSideMenuShow", true);

        this._initFeedbackList()
      },
      opened() {
        this.updateModalZIndex(this.$el)
        Bus.$on('setFeedbackZIndexTop',(ev)=>{
          this.updateModalZIndex(this.$el)
        })
      },
      resetForm() {
        this.appName = null;
        this.feedbackContent = null;
        this.linkway = null;
        this.isAno = null;
      },
      async submitFeedback() {

        if (!this.feedbackContent || this.feedbackContent === "<p><br></p>") {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '反馈内容不能为空~',
          });
          return;
        }

        let sysId = null;
        let sysname = null;
        if (this.appName) {
          sysId = this.appName.appid;
          sysname = this.appName.name;
        }

        let resp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_saveSuggestion", {
          sysId: sysId,
          sysname: sysname,
          content: this.feedbackContent,
          imgpath: null,
          anon: this.isAnon ? 1 : 0
        });

        if (resp.data.status) {
          this.$notify({
            group: 'global',
            title: resp.data.msg,
          });
          this.resetForm();
          this.close();
        } else {
          this.$notify({
            group: 'global',
            title: '网络错误',
          });
        }

      },
      //----------意见反馈列表-----------
      async _initFeedbackList() {
        let feedbackList = await axios.post(apiConfig.REQUEST_URL + '/ehall/front_getSuggestionList', {
          sysId: null
        })
        if (feedbackList.data.status) {
          this.feedbackList = feedbackList.data.data
        }
      },
      toFeedbackList() {
        this.currViewMode = !this.currViewMode
      },
      viewFeedbackDetail(feedback) {
        if(feedback.state!==1){
          this.$notify({
            group:'global',
            title:'温馨提示',
            text:`当前留言反馈为${this.getReplyStateDesc(feedback.state)}状态`
          })
          return
        }
        this.currFeedbackId = feedback.id
      },
      clearCurrFeedbackId() {
        this.currFeedbackId = null
      },
      getReplyStateDesc(val) {
        switch (val) {
          case 0:
            return '待回复'
          case 1:
            return '已回复'
          case 2:
            return '已忽略'
          default:
            return val
        }
      },
      getDescribe(val) {
        if (!val) {
          return '暂无内容'
        } else {
          return val
        }
      }
    },
    computed: {
      ...mapState(['systemList']),
    },
    mounted() {
    },
    filters: {

    },
    components: {multiselect, feedbackDetail}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .header
    button
      outline none
      background none
      padding 0 10px
      font-size 14px
      border 1px solid #cccccc
      margin-left 10px
      border-radius 5px
      transition 300ms

      &:hover
        background-color #eeeeee

  .content
    position relative
    overflow-y scroll !important
    padding 0 28px

    .feedbackListContainer
      .feedbackList
        li
          margin-top 10px
          font-size 14px
          line-height 2
          position relative
          padding 5px
          border-bottom 1px solid #eeeeee
          cursor pointer
          transition 300ms

          &:hover
            background-color #eeeeee

          & > h2
            border-left 3px solid #004a94
            padding-left 10px
            line-height 1
            margin 6px 0
            color #666

          & > p
            font-size 12px
            color #999

          & > .state
            line-height 1
            height 1em
            position absolute
            right 10px
            top 0
            bottom 0
            margin auto
            color #999

    .fdblock
      margin-top 20px

      & > p:first-of-type
        font-size 14px
        color #666666
        line-height 40px
        padding-left 20px
        position relative
        margin-bottom 10px

        &::after
          content: "";
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          background-color: #004a94;
          border-radius 50%
          width: 5px;
          height: 5px;

        .checkbox
          margin-top -3px
          vertical-align middle
          margin-right 5px

      & >>> .wangEditor-container
        width 660px
        overflow hidden
        border-radius 5px

      .linkway
        width 260px
        height 26px
        border-radius 13px
        padding 0 1em
        font-size 12px
        color #666666
        border 1px solid #cccccc

    .submitBtn
      font-size 12px
      border-radius 15px
      margin-top 40px
      margin-right 20px
      border 1px solid #004a94
      color #004a94
      background none
      outline none
      width 100px
      height 30px
      transition 300ms

      &:hover
        background-color #eeeeee


</style>



// WEBPACK FOOTER //
// src/components/globalComp/feedbackModal.vue